import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import TrialRouteGuard from '../components/TrialRouteGuard';
import TrialConsultationPopup from '../components/TrialConsultationPopup';
import useFetchIam from '../api/useFetchIam';
import SyncRequestWatcher from '../shared_job_posts/components/SyncRequestWatcher';

interface AgentLayoutProps {
  children: React.ReactNode;
}

export default function AgentLayout({ children }: AgentLayoutProps) {
  const { data: iam } = useFetchIam();
  const isTrial = iam?.plan_type === 'trial';

  return (
    <div className="l-wrapper">
      <Sidebar />
      <div className="l-main">
        <Header />
        <TrialRouteGuard>{children}</TrialRouteGuard>
      </div>
      {isTrial && <TrialConsultationPopup trialDaysRemaining={iam?.trial_days_remaining} />}
      <SyncRequestWatcher />
    </div>
  );
}
